module.exports = __webpack_public_path__ + "img/humor-pa-youtube-1.ed2e3bff.png";